import * as Sentry from '@sentry/react';

const isError = e => e instanceof Error;

const logException = err => {
  if (err?.sentryHandled || err?.error?.sentryHandled) {
    return;
  }

  let error = err;
  let extra;

  if (!isError(error)) {
    if (typeof error === 'string') {
      error = new Error(error);
    } else if (isError(error?.error)) {
      const { message, error: cause, ...rest } = err;
      error = new Error(message || cause.message, { cause });
      if (Object.keys(rest).length > 0) {
        extra = rest;
      }
    } else {
      error = new Error(JSON.stringify(error));
    }
  }

  if (extra) {
    Sentry.captureException(error, { extra });
  } else {
    Sentry.captureException(error);
  }
  if (process.env.NODE_ENV === 'development') {
    window.console && console.error && console.log(error);
  }
};

export default logException;
